import type { MouseEventHandler } from 'react';
import { IconButton } from '@ksyos/design-system';

export interface IBackButtonProps {
    disabled?: boolean;
    goBackFunction: MouseEventHandler<HTMLButtonElement>;
}

export function BackButton(props: IBackButtonProps) {
    return (
        <IconButton
            icon="caret-left"
            isDisabled={props.disabled}
            labelText="Ga terug"
            onClick={props.goBackFunction}
            size="small"
        />
    );
}
